import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AskTeacherService } from '../ask-teacher.service';

enum AskTeacherStatusType {
  DEFAULT,
  REQUESTING,
  SUCCESS,
  ERROR,
}

@Component({
  selector: 'lp2-ask-teacher',
  templateUrl: './ask-teacher.component.html',
  styleUrls: ['./ask-teacher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AskTeacherComponent {

  askTeacherContent: string;
  askTeacherStatus = AskTeacherStatusType.DEFAULT;
  askTeacherStatusType = AskTeacherStatusType;

  constructor(
    private askTeacherService: AskTeacherService, 
    public modal: NgbActiveModal,
    private cd: ChangeDetectorRef
    ) { }

  sendMessage() {
    if (
      !this.askTeacherContent ||
      this.askTeacherStatus === AskTeacherStatusType.REQUESTING
    ) {
      return;
    }
    this.updateStatus(AskTeacherStatusType.REQUESTING)

    this.askTeacherService
      .sendFeedback(this.askTeacherContent)
      .subscribe(
        () => {
          this.updateStatus(AskTeacherStatusType.SUCCESS);
        },
        () => {
          this.updateStatus(AskTeacherStatusType.ERROR);
        }
      );
  }

  updateStatus(newStatus: AskTeacherStatusType) {
    this.askTeacherStatus = newStatus;
    this.cd.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/ask-teacher/ask-teacher.component.ts